import flattenMessages from '../../../helpers/flattenMessages';

export default {
  en: flattenMessages({}, 'wallet-service-terms'),
  ja: flattenMessages({}, 'wallet-service-terms'),
};
